export default class {
    constructor() {}
}
